// Expiración GENÉRICA de las superficies de rollout (anuncios, coachmarks, encuestas).
//
// POR QUÉ existe: las superficies del framework solo desaparecían al DESCARTARLAS por-comercio
// (dismiss durable en localStorage). Sin una fecha de corte, un aviso viejo (encuesta de Bluetooth
// ya graduado, coachmark de precios de menú) sigue apareciéndoles indefinidamente a los comercios
// que nunca lo descartaron —visto en grabaciones de Clarity—. `isExpired` es el gate genérico y
// puro que cada superficie evalúa ADEMÁS de su gate de descarte: pasada la fecha, no se muestra.
//
// LIMITACIÓN (auto-supresión por graduación): la respuesta del backend (FeatureVersionResponse)
// solo expone `ga_forced` (boolean) y `sunset_date`, NO un timestamp de CUÁNDO graduó el
// experimento. Por eso la supresión "N días después de graduar" no es computable de forma limpia
// en el FE hoy; nos quedamos con la fecha ESTÁTICA `expiresAt` por superficie. Si el backend
// llegara a exponer `graduated_at`/`lifecycle_stage`, este helper es el lugar para derivarlo.

// ¿La superficie ya expiró? `expiresAt` es una fecha ISO ('YYYY-MM-DD' o ISO completo).
//
// Degradación SEGURA: ausente/vacío → NO expira (la superficie mantiene su comportamiento previo,
// gobernado solo por el descarte). Fecha INVÁLIDA → tampoco expira (nunca ocultamos por un dato
// malformado; preferimos seguir mostrando a suprimir por error). Nota: 'YYYY-MM-DD' se interpreta
// como medianoche UTC (semántica de `new Date('YYYY-MM-DD')`), granularidad de día — suficiente
// para una fecha de corte de campaña.
export function isExpired(expiresAt?: string | null): boolean {
  if (!expiresAt) return false;
  const cutoff = new Date(expiresAt).getTime();
  if (Number.isNaN(cutoff)) return false;
  return Date.now() > cutoff;
}

// ── Fechas de corte estáticas por superficie ────────────────────────────────────────────────
// Documentan la ventana de cada superficie que NO lleva su copy en strings.ts (el anuncio de una
// capacidad sí la lleva en su AnnouncementCopy.expiresAt). ISO 'YYYY-MM-DD' (medianoche UTC).

// Coachmark "Edita precios sin abrir el producto" (menu-v2, QuickPresentations). La feature está
// GA desde hace tiempo y el coachmark solo se apagaba al descartarlo por-comercio → seguía
// saliéndoles a stragglers (Clarity). Ventana de gracia para los que aún no lo descartan y corte.
export const PRICE_COACHMARK_EXPIRES_AT = '2026-08-31';

// Superficies del lanzamiento de Pedidos programados (capability_launch): coachmark "Actívalos
// aquí" (DeliveryDataV2) y encuesta de adopción por uso (ScheduledOrdersRolloutHost). Lanzamiento
// 2026-07-13; ~60 días de ventana y corte. Alineado con el `expiresAt` del anuncio en strings.ts.
export const SCHEDULED_ORDERS_LAUNCH_EXPIRES_AT = '2026-09-13';

// Encuestas de la feature impresion-ble (revert / permanencia / transición). La feature YA graduó;
// las encuestas de adopción/reversión no deben seguir disparándose. Corte cercano.
export const BLE_SURVEY_EXPIRES_AT = '2026-08-15';
